<template>

    <overtime
        :automatically-include-overtime="getAuth.settings.archibase.settings.automatically_calculate_overtime"
        :overtime-uri="route('api.v1.hr.users.overtime.index', {id:getHrUser.uuid})"
    ></overtime>

</template>

<script>

import {mapGetters} from "vuex";
import Overtime from "../../../components/TimeRegistration/Overtime";

export default {

    components: {
        Overtime,
    },

    computed: {
        ...mapGetters([
            'getAuth',
            'getHrUser',
        ]),
    },

    metaInfo: {
        title:'Overuren bekijken',
    },

    name:'HrUsersOvertime',

}

</script>
